export default "__VITE_ASSET__tYblFstV__"